export default "__VITE_ASSET__D29_ABpc__"